import React, { Children, ReactElement, cloneElement } from 'react';
import { getEnvironment } from '@minecraft.environment';
import CloudinaryDocumentPreview from './CloudinaryDocumentPreview/CloudinaryDocumentPreview';
import CloudinaryDocumentDownload from './CloudinaryDocumentDownload/CloudinaryDocumentDownload';

const environment = getEnvironment();
const cloudinaryHotStorage = environment.CN_HOT_CLOUDNAME;

export type CloudinaryDocumentProps = {
  guid?: string;
  fileKey: string;
  children: ReactElement | ReactElement[];
};

const CloudinaryDocument = ({ guid, children, fileKey }: CloudinaryDocumentProps): JSX.Element => {
  const childElements = Children.toArray(children);

  return (
    <>
      {childElements.map((element: ReactElement) =>
        cloneElement(element, { cloudName: cloudinaryHotStorage, guid, fileKey })
      )}
    </>
  );
};

CloudinaryDocument.Preview = CloudinaryDocumentPreview;
CloudinaryDocument.Download = CloudinaryDocumentDownload;

export default CloudinaryDocument;
